





















import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { QueryPatientEduModel,DeleteEducationModel } from "@/api/pdOutPatient/pdEducation/pdPatientEdu";
import AddOrEditEduModel from './addOrEditEduModel.vue'
@Component({
    components: { AddOrEditEduModel},
})
export default class extends AbpBase {
    data: any = [];
    loading: boolean = false;
    totalCount: number = 0;
    showEduModel: boolean = false;
    queryCondition = {
        page: 1,
        pageSize: 10,
        queryString: "",
    };
    title:string="";
    EduModelData:any={};

    columns = [
        {
            title: "模板名称",
            key: "modelName",
            width: 120,
        },
        {
            title: "模板说明",
            key: "modelNote",
        },
        {
            title: "操作",
            width: 170,
            render: (h: any, p: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "10px",
                            },
                            on: {
                                click: () => {
                                    this.editModel(p.row)
                                },
                            },
                        },
                        "编辑"
                    ),
                    h(
                        "Button",
                        {
                            props: {
                            type: "error",
                            size: "small"
                            },
                            style: {
                            marginRight: "10px"
                            },
                            on: {
                                click: () => {
                                      this.deleteModel(p.row.id);
                                }
                            }
                        },
                        "删除"
                    )
                   
                ]);
            },
        },
    ];

    pageChange(val: any) {
        this.queryCondition.page = val;
        this.getData();
    }

    query() {
        this.queryCondition.page = 1;
        this.getData();
    }

    async getData() {
        this.loading = true;
        let res = await QueryPatientEduModel(this.queryCondition);
        this.data = res.items;
        this.totalCount = res.totalCount;
        this.loading = false;
    }
    addModel(){
        this.EduModelData = {saveType:'新增',id:0};
        this.title = '新增宣教计划模板'
        this.showEduModel = true;
    }
    editModel(item:any){
        this.EduModelData = item;
        this.EduModelData.saveType='编辑';
        this.title = '编辑宣教计划模板'
        this.showEduModel = true;
    }
    created() {
        this.query();
    }
    deleteModel(id:number){
        this.$confirm("确定要删除吗？", "提示").then(() => {
            this.loading = true;
            DeleteEducationModel(id).then(res => {
                this.getData();
            });
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdEducationModel/index.vue